import { isDefined } from "@omni/utils/helper.utils";

import { BundleProductModel } from "@/api/mappers/productBundles.mapper";
import { ProductTileLayout } from "@/components/Product/ProductTile/productTile.config";
import { ProductTile } from "@/components/Product/ProductTile/productTile.container";
import {
    BreakpointMatches,
    useBreakpoint
} from "@/utils/breakpoints/breakpoints.provider";

import "./bundleProduct.scss";

const getProductTileLayout = (breakpoints: BreakpointMatches) => {
    if (!isDefined(breakpoints)) return ProductTileLayout.BUNDLE_VERTICAL;

    if (breakpoints.xl) {
        return ProductTileLayout.BUNDLE_VERTICAL;
    } else {
        return ProductTileLayout.BUNDLE_HORIZONTAL;
    }
};

type BundleProductComponentProps = {
    bundleProduct: BundleProductModel;
};

const BundleProductComponent = ({
    bundleProduct
}: BundleProductComponentProps) => {
    const { breakpoints } = useBreakpoint();

    const productTileLayout = getProductTileLayout(breakpoints);

    return (
        <ProductTile
            className={"bundleProduct"}
            sku={bundleProduct.product.sku}
            product={bundleProduct.product}
            amount={bundleProduct.quantity}
            allowInstantAddToCart={false}
            productTileConfig={{
                amountOfFeatures: 0,
                tilePadding: false,
                hoverEffect: breakpoints.xl,
                horizontal: !breakpoints.xl,
                border: breakpoints.xl,
                components: productTileLayout()
            }}
        />
    );
};

export { BundleProductComponent };
